import * as normalize from 'utils/normalize';
import getPatientName from 'utils/print/getPatientName';
import getPatientFullAddress from 'utils/print/getPatientFullAddress';
import getPatientPhone1 from 'utils/print/getPatientPhone1';
import getPatientPhone2 from 'utils/print/getPatientPhone2';
import getPatientPhone3 from 'utils/print/getPatientPhone3';
import getPatientMedicareID from 'utils/print/getPatientMedicareID';
import getOrderLinePlaceOfService from 'utils/print/getOrderLinePlaceOfService';
import getPatientDob1 from 'utils/print/getPatientDob1';
import getPatientDob2 from 'utils/print/getPatientDob2';
import getPatientDob3 from 'utils/print/getPatientDob3';
import getPatientGender from 'utils/print/getPatientGender';
import getPatientHeightIn from 'utils/print/getPatientHeightIn';
import getPatientWeight from 'utils/print/getPatientWeight';
import getPrescriberName from 'utils/print/getPrescriberName';
import getPrescriberFullAddress from 'utils/print/getPrescriberFullAddress';
import getPrescriberPhone1 from 'utils/print/getPrescriberPhone1';
import getPrescriberPhone2 from 'utils/print/getPrescriberPhone2';
import getPrescriberPhone3 from 'utils/print/getPrescriberPhone3';
import getPrescriberNPI from 'utils/print/getPrescriberNPI';
import getDiagnosisCode from 'utils/print/getDiagnosisCode';
import getSupplierName from 'utils/print/getSupplierName';
import getSupplierFullAddress from 'utils/print/getSupplierFullAddress';
import getSupplierPhone1 from 'utils/print/getSupplierPhone1';
import getSupplierPhone2 from 'utils/print/getSupplierPhone2';
import getSupplierPhone3 from 'utils/print/getSupplierPhone3';
import getSupplierNSCorNPI from 'utils/print/getSupplierNSCorNPI';
import getOrderLineHCPCSCode from 'utils/print/getOrderLineHCPCSCode';
import getSignature from 'utils/print/getSignature';

const CMS10126 = {
  ID: 2,
  Name: 'CMS-10126 External and Parenteral Nutrition',
  Type: 'CMS',
  Format: 'letter',
  Orientation: 'p',
  Pages: [
    {
      ID: 1,
      imageUrl: 'assets/documents/CMS-10126/1.js',
      fields: [
        {
          name: 'Certification Type/Date INITIAL 1',
          type: 'text',
          x: 81,
          y: 37,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date INITIAL 2',
          type: 'text',
          x: 87.5,
          y: 37,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date INITIAL 3',
          type: 'text',
          x: 94.5,
          y: 37,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date REVISED 1',
          type: 'text',
          x: 118.5,
          y: 37,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date REVISED 2',
          type: 'text',
          x: 125.5,
          y: 37,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date REVISED 3',
          type: 'text',
          x: 132.5,
          y: 37,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date RECERTIFICATION 1',
          type: 'text',
          x: 171,
          y: 37,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date RECERTIFICATION 2',
          type: 'text',
          x: 177.5,
          y: 37,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date RECERTIFICATION 3',
          type: 'text',
          x: 184.5,
          y: 37,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Name',
          type: 'text',
          getValue: getPatientName,
          x: 14.5,
          y: 46,
          width: 92,
        },
        {
          name: 'Patient Address',
          type: 'text',
          getValue: getPatientFullAddress,
          x: 14.5,
          y: 50,
          width: 92,
          height: 8.5,
          multiline: true,
        },
        {
          name: 'Phone 1',
          type: 'text',
          getValue: getPatientPhone1,
          x: 15,
          y: 59,
          width: 10,
        },
        {
          name: 'Phone 2',
          type: 'text',
          getValue: getPatientPhone2,
          x: 27,
          y: 59,
          width: 10,

        },
        {
          name: 'Phone 3',
          type: 'text',
          getValue: getPatientPhone3,
          x: 40,
          y: 59,
          width: 14,
        },
        {
          name: 'Medicare ID',
          type: 'text',
          getValue: getPatientMedicareID,
          x: 71,
          y: 59,
          width: 35.5,
        },
        {
          name: 'Supplier Name',
          type: 'text',
          getValue: getSupplierName,
          x: 147,
          y: 46,
          width: 54,
        },
        {
          name: 'Supplier Address',
          type: 'text',
          getValue: getSupplierFullAddress,
          x: 109,
          y: 50.1,
          width: 92,
          height: 8.5,
          multiline: true,
        },
        {
          name: 'Supplier Phone 1',
          type: 'text',
          getValue: getSupplierPhone1,
          x: 112,
          y: 59,
          width: 10,
          maxLength: 3,
          normalize: normalize.number,
        },
        {
          name: 'Supplier Phone 2',
          type: 'text',
          getValue: getSupplierPhone2,
          x: 123,
          y: 59,
          width: 10,
          maxLength: 3,
          normalize: normalize.number,
        },
        {
          name: 'Supplier Phone 3',
          type: 'text',
          getValue: getSupplierPhone3,
          x: 136,
          y: 59,
          width: 14,
          maxLength: 4,
          normalize: normalize.number,
        },
        {
          name: 'Supplier NSC or NPI',
          type: 'text',
          getValue: getSupplierNSCorNPI,
          x: 169,
          y: 59,
          width: 23,
        },
        {
          name: 'Place Of Service',
          type: 'text',
          getValue: props => getOrderLinePlaceOfService({ ...props, index: 0 }),
          x: 40,
          y: 66,
          width: 36,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Date of Birth 1',
          type: 'text',
          getValue: getPatientDob1,
          x: 121.5,
          y: 65.5,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Date of Birth 2',
          type: 'text',
          getValue: getPatientDob2,
          x: 128.5,
          y: 65.5,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Date of Birth 3',
          type: 'text',
          getValue: getPatientDob3,
          x: 135,
          y: 65.5,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Gender',
          type: 'text',
          getValue: getPatientGender,
          x: 148,
          y: 65.5,
          width: 5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Height',
          type: 'text',
          getValue: getPatientHeightIn,
          x: 168,
          y: 65.5,
          width: 7,
          maxLength: 3,
          normalize: normalize.number,
        },
        {
          name: 'Patient Weight',
          type: 'text',
          getValue: getPatientWeight,
          x: 185,
          y: 65.5,
          width: 7,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Supply Item/Service Procedure Code(s) 1',
          type: 'text',
          getValue: props => getOrderLineHCPCSCode({ ...props, index: 0 }),
          x: 83,
          y: 74,
          width: 23,
        },
        {
          name: 'Supply Item/Service Procedure Code(s) 2',
          type: 'text',
          getValue: props => getOrderLineHCPCSCode({ ...props, index: 1 }),
          x: 83,
          y: 79,
          width: 23,
        },
        {
          name: 'Supply Item/Service Procedure Code(s) 3',
          type: 'text',
          getValue: props => getOrderLineHCPCSCode({ ...props, index: 2 }),
          x: 83,
          y: 84,
          width: 23,
        },
        {
          name: 'Supply Item/Service Procedure Code(s) 4',
          type: 'text',
          getValue: props => getOrderLineHCPCSCode({ ...props, index: 3 }),
          x: 83,
          y: 89,
          width: 23,
        },
        {
          name: 'Prescriber Name',
          type: 'text',
          getValue: getPrescriberName,
          x: 109,
          y: 78.1,
          width: 92,
        },
        {
          name: 'Prescriber Email',
          type: 'text',
          getValue: getPrescriberFullAddress,
          x: 109,
          y: 81.5,
          width: 92,
          height: 8.5,
          multiline: true,
        },
        {
          name: 'Prescriber Phone 1',
          type: 'text',
          getValue: getPrescriberPhone1,
          x: 111,
          y: 90,
          width: 10,
          maxLength: 3,
          normalize: normalize.number,
        },
        {
          name: 'Prescriber Phone 2',
          type: 'text',
          getValue: getPrescriberPhone2,
          x: 123,
          y: 90,
          width: 10,
          maxLength: 3,
          normalize: normalize.number,
        },
        {
          name: 'Prescriber Phone 3',
          type: 'text',
          getValue: getPrescriberPhone3,
          x: 136,
          y: 90,
          width: 14,
          maxLength: 4,
          normalize: normalize.number,
        },
        {
          name: 'Prescriber NSC or NPI',
          type: 'text',
          getValue: getPrescriberNPI,
          x: 170,
          y: 90,
          width: 23,
        },
        {
          name: 'EST LENGTH OF NEED',
          type: 'text',
          x: 67,
          y: 95.5,
          width: 9,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'DIAGNOSIS CODES',
          type: 'text',
          getValue: getDiagnosisCode,
          x: 135,
          y: 95.5,
          width: 66,
        },
        {
          name: 'Is there documentation in the medical record that supports the patient having a permanent non-function or disease of the structures that normally permit food to reach or be absorbed from the small bowel?',
          type: 'radio',
          options: [
            {
              x: 19.5,
              y: 113.5,
              width: 3,
              height: 3,
              value: 'Y',
            },
            {
              x: 31,
              y: 113.5,
              width: 3,
              height: 3,
              value: 'N',
            },
          ],
        },
        {
          name: 'Is the enteral nutrition being provided for administration via tube? (i.e., gastrostomy tube, jejunostomy tube, nasogastric tube)',
          type: 'radio',
          options: [
            {
              x: 19.5,
              y: 123.5,
              width: 3,
              height: 3,
              value: 'Y',
            },
            {
              x: 31,
              y: 123.5,
              width: 3,
              height: 3,
              value: 'N',
            },
          ],
        },
        {
          name: 'Print Supply Item/Service Procedure Code(s) of product a)',
          type: 'text',
          x: 18,
          y: 131,
          width: 23,
        },
        {
          name: 'Print Supply Item/Service Procedure Code(s) of product b)',
          type: 'text',
          x: 18,
          y: 135.5,
          width: 23,
        },
        {
          name: 'Calories per day for each corresponding Supply Item/Service Procedure Code(s) a)',
          type: 'text',
          x: 18,
          y: 145,
          width: 23,
        },
        {
          name: 'Calories per day for each corresponding Supply Item/Service Procedure Code(s) b)',
          type: 'text',
          x: 18,
          y: 148.5,
          width: 23,
        },
        {
          name: 'Check the number for method of administration? 1 – Syringe 2 – Gravity 3 – Pump 4 – Oral (i.e. drinking)',
          type: 'radio',
          options: [
            {
              x: 14,
              y: 161,
              width: 3,
              height: 3,
              value: '1',
            },
            {
              x: 21.5,
              y: 161,
              width: 3,
              height: 3,
              value: '2',
            },
            {
              x: 28.5,
              y: 161,
              width: 3,
              height: 3,
              value: '3',
            },
            {
              x: 36,
              y: 161,
              width: 3,
              height: 3,
              value: '4',
            },
          ],
        },
        {
          name: 'Days per week administered or infused (Enter 1–7)',
          type: 'text',
          x: 23,
          y: 168,
          width: 10,
          maxLength: 1,
          normalize: normalize.number,
        },
        {
          name: 'Is there documentation in the medical record that supports the patient having permanent disease of the gastrointestinal tract causing malabsorption severe enough to prevent maintenance of weight and strength commensurate with the patient’s overall health status?',
          type: 'radio',
          options: [
            {
              x: 19,
              y: 179,
              width: 3,
              height: 3,
              value: 'Y',
            },
            {
              x: 31,
              y: 179,
              width: 3,
              height: 3,
              value: 'N',
            },
          ],
        },
        {
          name: 'Amino Acid (ml/day)',
          type: 'text',
          x: 68,
          y: 192.5,
          width: 14,
          normalize: normalize.number,
        },
        {
          name: 'Amino Acid concentration %',
          type: 'text',
          x: 94,
          y: 192.5,
          width: 20,
          normalize: normalize.number,
        },
        {
          name: 'Amino Acid gms protein/day',
          type: 'text',
          x: 137,
          y: 192.5,
          width: 9,
          normalize: normalize.number,
        },
        {
          name: 'Dextrose (ml/day)',
          type: 'text',
          x: 64,
          y: 197,
          width: 18,
          normalize: normalize.number,
        },
        {
          name: 'Dextrose concentration %',
          type: 'text',
          x: 94,
          y: 197,
          width: 20,
          normalize: normalize.number,
        },
        {
          name: 'Lipids (ml/day)',
          type: 'text',
          x: 60,
          y: 201,
          width: 22,
          normalize: normalize.number,
        },
        {
          name: 'Lipids days/week',
          type: 'text',
          x: 94,
          y: 201,
          width: 20,
          normalize: normalize.number,
        },
        {
          name: 'Lipids concentration %',
          type: 'text',
          x: 129,
          y: 201,
          width: 16,
          normalize: normalize.number,
        },
        {
          name: 'Check the number for the route of administration. 1 – Central Line (Including PICC) 2 – Hemodialysis Access Line 3 – Peritoneal Catheter',
          type: 'radio',
          options: [
            {
              x: 18.5,
              y: 210.5,
              width: 3,
              height: 3,
              value: '1',
            },
            {
              x: 25.5,
              y: 210.5,
              width: 3,
              height: 3,
              value: '2',
            },
            {
              x: 33,
              y: 210.5,
              width: 3,
              height: 3,
              value: '3',
            },
          ],
        },
        {
          name: 'Signature',
          type: 'signature',
          getValue: getSignature,
          x: 50,
          y: 238,
          width: 90,
          height: 8,
        },
        {
          name: 'Date 1',
          type: 'text',
          x: 160,
          y: 242,
          width: 6,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Date 2',
          type: 'text',
          x: 168,
          y: 242,
          width: 6,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Date 3',
          type: 'text',
          x: 176,
          y: 242,
          width: 6,
          maxLength: 2,
          normalize: normalize.number,
        },
      ],
    },
  ],
};

export default CMS10126;



// WEBPACK FOOTER //
// ./src/config/documents/CMS-10126.js